const React = require('react');
const T = require('prop-types');
const { default: Styled } = require('styled-components');
const { default: Menu } = require('@mui/material/Menu');
const { default: MenuItem } = require('@mui/material/MenuItem');
const IconMenuButton = require('components/IconMenuButton');
const { default: HamburgerIcon } = require('@mui/icons-material/Menu');

const { default: Classes } = require('./styles.scss');

const internals = {};

module.exports = class MaterialMenu extends React.PureComponent {

    static propTypes = {
        menuOptions: T.arrayOf(T.shape({
            name: T.string,
            action: T.func,
            props: T.object
        })),
        iconElement: T.any,
        anchorOrigin: T.object,
        buttonRef: T.any,
        'data-focus-outline': T.string
    }

    constructor() {

        super();

        this.state = {
            menuOpen: false,
            anchorEl: null,
            wide: false
        };

        this.handleClose = this._handleClose.bind(this);
        this.handleClick = this._handleClick.bind(this);

        this.mql = window.matchMedia('screen and (min-width: 600px)');
    }

    UNSAFE_componentWillMount() {

        this.handleMediaQuery(this.mql);
        this.mql.addListener(this.handleMediaQuery);
    }

    handleMediaQuery = (mql) => {

        this.setState({ wide: !!mql.matches });
    }

    _handleClick(event){

        this.setState({ menuOpen: true, anchorEl: event.currentTarget });
    }

    onKeyDown = (event) => {

        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleClick(event);
        }

        if (event.key === ' ') {
            event.preventDefault();
        }
    }

    onKeyUp = (event) => {

        if (event.key === ' ') {
            event.preventDefault();
            this.handleClick(event);
        }
    }

    _handleClose() {

        this.setState({ menuOpen: false,anchorEl: null });
    }

    render() {

        const { menuOptions, iconElement, anchorOrigin, buttonRef, 'data-focus-outline': dataFocusOutline } = this.props;
        const { menuOpen, anchorEl } = this.state;
        const { ButtonIconContainer } = internals;
        const resolvedAnchorOrigin = {
            vertical: 'bottom',
            horizontal: 'right',
            ...anchorOrigin
        };

        if (menuOptions.length === 0) {
            return null;
        }

        return (
            <>
                {/* TODO Band-aid for now – we should refactor later */}
                {iconElement && (
                    <ButtonIconContainer
                        onClick={this.handleClick}
                        onKeyDown={this.onKeyDown}
                        onKeyUp={this.onKeyUp}
                        ref={buttonRef}
                        tabIndex={0}
                        role='button'
                        aria-haspopup='true'
                        aria-expanded={menuOpen}
                        aria-label='options'
                        data-focus-outline={dataFocusOutline}
                    >
                        {iconElement}
                    </ButtonIconContainer>
                )}
                {!iconElement && (
                    <IconMenuButton
                        focusVisibleClassName={Classes.iconBtnFocusVisible}
                        aria-expanded={menuOpen}
                        onClick={this.handleClick}
                        ref={buttonRef}
                        aria-label='options'
                        aria-haspopup='true'
                    >
                        <HamburgerIcon />
                    </IconMenuButton>
                )}
                <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={resolvedAnchorOrigin}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: resolvedAnchorOrigin.horizontal
                    }}
                    open={menuOpen}
                    onClose={this.handleClose}
                >
                    {menuOptions.map((menuItem, i) => {

                        return <MenuItem
                            key={menuItem.name + i}
                            onClick={() => {

                                menuItem.action();
                                this.handleClose();
                            }}
                            {...menuItem.props}
                        >{menuItem.name}</MenuItem>;
                    })}
                </Menu>
            </>
        );
    }
};

internals.ButtonIconContainer = Styled.div`
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    width: fit-content;
    margin-left: auto;
`;
